var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6632 7.09936C17.0343 7.09936 18.1458 5.99513 18.1458 4.63299C18.1458 3.27086 17.0343 2.16663 15.6632 2.16663C14.2921 2.16663 13.1806 3.27086 13.1806 4.63299C13.1806 5.99513 14.2921 7.09936 15.6632 7.09936ZM6.97396 6.27723C7.65952 6.27723 8.21528 5.72512 8.21528 5.04405C8.21528 4.36298 7.65952 3.81087 6.97396 3.81087C6.2884 3.81087 5.73264 4.36298 5.73264 5.04405C5.73264 5.72512 6.2884 6.27723 6.97396 6.27723ZM9.87037 23.8333C13.5267 23.8333 16.4907 20.4554 16.4907 16.2884C16.4907 12.1215 13.5267 8.7436 9.87037 8.7436C6.21404 8.7436 3.25 12.1215 3.25 16.2884C3.25 20.4554 6.21404 23.8333 9.87037 23.8333ZM23.1111 13.2653C23.1111 14.4004 22.1848 15.3206 21.0422 15.3206C19.8996 15.3206 18.9734 14.4004 18.9734 13.2653C18.9734 12.1302 19.8996 11.21 21.0422 11.21C22.1848 11.21 23.1111 12.1302 23.1111 13.2653ZM23.1111 4.22193C23.1111 4.903 22.5554 5.45511 21.8698 5.45511C21.1842 5.45511 20.6285 4.903 20.6285 4.22193C20.6285 3.54086 21.1842 2.98875 21.8698 2.98875C22.5554 2.98875 23.1111 3.54086 23.1111 4.22193ZM10.0208 17.5138C11.2673 17.5138 12.2778 16.5034 12.2778 15.2569C12.2778 14.0104 11.2673 13 10.0208 13C8.77436 13 7.76389 14.0104 7.76389 15.2569C7.76389 16.5034 8.77436 17.5138 10.0208 17.5138Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStores);
export default __webpack_public_path__ + "static/media/stores.a990271b8bd050af1b74564d26fa52b6.svg";
export { ForwardRef as ReactComponent };